import React from "react";
import styled from "styled-components";
import Section from "./Section";

const AllSections = () => {
  const car_lst = [
    {
      title: "Model S",
      description: "Order Online for Touchless Delivery",
      bgImg: "model-s.jpg",
      leftBtnText: "Custom Order",
      rightBtnText: "Existing Inventory",
      id: "model-s",
    },
    {
      title: "Model Y",
      description: "Order Online for Touchless Delivery",
      bgImg: "model-y.jpg",
      leftBtnText: "Custom Order",
      rightBtnText: "Existing Inventory",
      id: "model-y",
    },
    {
      title: "Model 3",
      description: "Order Online for Touchless Delivery",
      bgImg: "model-3.jpg",
      leftBtnText: "Custom Order",
      rightBtnText: "Existing Inventory",
      id: "model-3",
    },
    {
      title: "Model X",
      description: "Order Online for Touchless Delivery",
      bgImg: "model-x.jpg",
      leftBtnText: "Custom Order",
      rightBtnText: "Existing Inventory",
      id: "model-x",
    },
    {
      title: "Lowest Cost Solar Panels in America",
      description: "Money-back guarantee",
      bgImg: "solar-panel.jpg",
      leftBtnText: "Order Now",
      rightBtnText: "Learn More",
      id: "solar-panels",
    },
    {
      title: "Solar for New Roofs",
      description: "Solar Roof Costs Less Than a New Roof",
      bgImg: "solar-roof.jpg",
      leftBtnText: "Order Now",
      rightBtnText: "Learn More",
      id: "solar-roofs",
    },
    {
      title: "Accessories",
      description: "",
      bgImg: "accessories.jpg",
      leftBtnText: "Shop Now",
      rightBtnText: "",
    },
  ];
  return (
    <Container>
      {car_lst.map((item, index) => (
        <Section
          key={index}
          id={item.id}
          title={item.title}
          description={item.description}
          bgImg={item.bgImg}
          leftBtnText={item.leftBtnText}
          rightBtnText={item.rightBtnText}
        />
      ))}
    </Container>
  );
};

export default AllSections;

const Container = styled.div``;
